import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Reveal, KineticLines } from "@/components/common/Reveal";

// Reusable inner-page hero with breadcrumb
export const PageHero = ({ eyebrow, titleLines = [], subtitle, crumbs = [] }) => (
  <section
    data-testid="page-hero"
    className="relative overflow-hidden border-b border-brand-line bg-brand-soft pt-32 md:pt-40"
  >
    <div className="mx-auto max-w-[1440px] px-6 pb-16 md:px-12 md:pb-20 lg:px-20">
      <nav className="mb-8 flex flex-wrap items-center gap-1.5 text-sm text-brand-muted">
        <Link to="/" className="hover:text-brand-blue">Home</Link>
        {crumbs.map((c) => (
          <span key={c.to || c.label} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5" />
            {c.to ? (
              <Link to={c.to} className="hover:text-brand-blue">{c.label}</Link>
            ) : (
              <span className="text-brand-dark">{c.label}</span>
            )}
          </span>
        ))}
      </nav>

      {eyebrow && (
        <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
          {eyebrow}
        </span>
      )}
      <h1 className="mt-4 font-display text-4xl font-semibold leading-[0.98] tracking-tight text-brand-dark md:text-6xl lg:text-7xl">
        <KineticLines lines={titleLines} />
      </h1>
      {subtitle && (
        <Reveal delay={0.25}>
          <p className="mt-6 max-w-2xl text-base text-brand-muted md:text-lg">{subtitle}</p>
        </Reveal>
      )}
    </div>
  </section>
);
